// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__wWSzs","focado":"OptionSelect_focado__uOq1O"};